"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = exports.isInEnum = exports.isPercentage = exports.isInRange = exports.isNumber = void 0;
// Check if input is a number.
function isNumber(value) {
    const numberRegExp = /^\d+(\.\d+)?$/;
    return numberRegExp.test(value);
}
exports.isNumber = isNumber;
// Check if input is within an inclusive-inclusive range.
function isInRange(value, lower, upper) {
    return isNumber(value) && value >= lower && value <= upper;
}
exports.isInRange = isInRange;
// Check if input is a percentage.
function isPercentage(value) {
    const percentageRegExp = /^\d+(\.\d+)?%$/;
    return percentageRegExp.test(value) && isInRange(parseFloat(value), 0, 100);
}
exports.isPercentage = isPercentage;
// Check if input is part of an enumerated type.
function isInEnum(value, type) {
    return Object.values(type).includes(value);
}
exports.isInEnum = isInEnum;
// Validation messages.
exports.messages = {
    percentageValidationMessage: 'Result must be a percentage, e.g. 90%',
    numericValidationMessage: 'Result must be a numerical value.',
    enumValidationMessage: 'You must select an option.',
    rangeValidationMessage: (lower, upper) => {
        return `Result must be between ${lower} and ${upper}.`;
    },
};
//# sourceMappingURL=common.js.map